/* Sui Story — header & global chrome behaviour.
   Runs once (header/footer persist across Barba swaps). Re-syncs active-nav and
   counts on the 'suistory:page:init' / cart / wishlist events. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    // --- Sticky shrink ---
    var header = document.querySelector('[data-header]');
    if (header) {
      var ticking = false;
      var apply = function () {
        var y = window.scrollY || document.documentElement.scrollTop || 0;
        header.classList.toggle('is-scrolled', y > 24);
        ticking = false;
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { window.requestAnimationFrame(apply); ticking = true; }
      }, { passive: true });
      apply();
    }

    // --- Mobile menu overlay (full-screen; burger morphs to X) ---
    var overlay = document.getElementById('MenuDrawer');
    function setMenu(open) {
      if (!overlay) return;
      overlay.classList.toggle('is-open', open);
      if (open) overlay.removeAttribute('inert'); else overlay.setAttribute('inert', '');
      overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.classList.toggle('nav-locked', open);
      if (header) header.classList.toggle('nav-open', open);
      document.querySelectorAll('[data-menu-toggle]').forEach(function (burger) {
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
    }
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-menu-toggle]');
      if (toggle) {
        e.preventDefault();
        var willOpen = !(overlay && overlay.classList.contains('is-open'));
        // Opened from the bottom bar -> overlay grows from the bottom; top burger -> from the top.
        if (overlay && willOpen) {
          overlay.classList.toggle('nav-overlay--from-bottom', !!toggle.closest('[data-bottom-nav]'));
        }
        setMenu(willOpen);
        return;
      }
      // Following any menu link closes the overlay (Barba swaps the page beneath it).
      if (e.target.closest('[data-menu-link]')) setMenu(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) setMenu(false);
    });

    // --- Search trigger (full overlay arrives in the search task; fall back to /search) ---
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-search-open]');
      if (!trigger) return;
      e.preventDefault();
      var dlg = document.getElementById('SearchDialog');
      if (dlg && dlg.showModal) {
        dlg.showModal();
        var input = dlg.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 60);
      } else {
        window.location.href = root + 'search';
      }
    });

    // --- Active bottom-nav state (updates across Barba swaps) ---
    function updateActive() {
      var path = window.location.pathname;
      document.querySelectorAll('[data-bottom-nav] [data-nav]').forEach(function (item) {
        var key = item.getAttribute('data-nav');
        var on = (key === 'index' && (path === root || path === '/')) ||
                 (key === 'cart' && path.indexOf('/cart') === 0) ||
                 (key === 'wishlist' && path.indexOf('/pages/wishlist') !== -1);
        item.classList.toggle('is-active', !!on);
      });
      // Active-state helper shared by the menu overlay and the desktop header nav.
      function syncLinks(links) {
        links.forEach(function (a) {
          var href = a.getAttribute('href') || '';
          var on;
          if (href === root || href === '/') on = (path === root || path === '/');
          else { var clean = href.replace(/\/+$/, ''); on = clean !== '' && path.indexOf(clean) === 0; }
          a.classList.toggle('is-active', !!on);
        });
      }
      // Mobile menu overlay: highlight the current page (also after Barba swaps).
      var ov = document.getElementById('MenuDrawer');
      if (ov) syncLinks(ov.querySelectorAll('.nav-overlay__link'));
      // Desktop header nav: the header persists across Barba swaps, so its server-rendered
      // is-active would otherwise stay stuck on the previous page (e.g. About on a catalog page).
      syncLinks(document.querySelectorAll('.header-nav__link'));
    }
    updateActive();
    document.addEventListener('suistory:page:init', updateActive);

    // --- Badge updates (cart.js / wishlist.js dispatch these) ---
    function setBadges(selector, count) {
      document.querySelectorAll(selector).forEach(function (b) {
        b.textContent = count;
        if (count > 0) b.removeAttribute('hidden'); else b.setAttribute('hidden', '');
      });
    }
    document.addEventListener('suistory:cart:updated', function (e) {
      if (e.detail && typeof e.detail.item_count === 'number') setBadges('[data-cart-count]', e.detail.item_count);
    });
    document.addEventListener('suistory:wishlist:updated', function (e) {
      var c = (e.detail && typeof e.detail.count === 'number') ? e.detail.count : 0;
      setBadges('[data-wishlist-count]', c);
    });
  });
})();
